import script from "./FranchiseDayLocation.vue?vue&type=script&setup=true&lang=js"
export * from "./FranchiseDayLocation.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__

/* vue-cli-plugin-import-components */

import AudienceNeue from "@/components/neue/AudienceNeue.vue";
import EmptyState from "@/components/neue/EmptyState.vue";
import FranchiseDayHeader from "@/components/franchise/FranchiseDayHeader.vue";
import NeueLoading from "@/components/neue/NeueLoading.vue";
import NeueWell from "@/components/neue/NeueWell.vue";
import SecondaryNav from "@/components/SecondaryNav.vue";
script.components = Object.assign({}, { AudienceNeue, EmptyState, FranchiseDayHeader, NeueLoading, NeueWell, SecondaryNav }, script.components);if ('__vccOpts' in script) { script.__o = script.__o || {}; script.__o.components = Object.assign({}, { AudienceNeue, EmptyState, FranchiseDayHeader, NeueLoading, NeueWell, SecondaryNav }, script.__o.components);}